import { defaultFill } from '../../utils/constants';
var muiCancelFill16 = {
    paths: [
        {
            path: 'M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M10.1213203,4.46446609 L8,6.58578644 L5.87867966,4.46446609 L4.46446609,5.87867966 L6.58578644,8 L4.46446609,10.1213203 L5.87867966,11.5355339 L8,9.41421356 L10.1213203,11.5355339 L11.5355339,10.1213203 L9.41421356,8 L11.5355339,5.87867966 L10.1213203,4.46446609 Z',
            fill: defaultFill,
        },
    ],
    title: 'Cancel',
    width: 16,
    height: 16,
};
var muiCancelFill24 = {
    paths: [
        {
            path: 'M11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 Z M14.1819805,5.69669914 L11,8.87867966 L7.81801948,5.69669914 L5.69669914,7.81801948 L8.87867966,11 L5.69669914,14.1819805 L7.81801948,16.3033009 L11,13.1213203 L14.1819805,16.3033009 L16.3033009,14.1819805 L13.1213203,11 L16.3033009,7.81801948 L14.1819805,5.69669914 Z',
            fill: defaultFill,
        },
    ],
    title: 'Cancel',
    width: 22,
    height: 22,
};
var muiCancelFill = {
    base: muiCancelFill16,
    smIcon: muiCancelFill16,
    lgIcon: muiCancelFill24,
};
export { muiCancelFill };
//# sourceMappingURL=cancelFill.js.map